export default {"src":"/_next/static/media/ky.6eac70d0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};